import * as CarbonComponents from '@carbon/react';
export const SideNav = CarbonComponents.SideNav;
export const SideNavItems = CarbonComponents.SideNavItems;
export const SideNavMenu = CarbonComponents.SideNavMenu;
export const SideNavMenuItem = CarbonComponents.SideNavMenuItem;
export const SideNavLink = CarbonComponents.SideNavLink;
export const SideNavDivider = CarbonComponents.SideNavDivider;
